/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import { Button, Grid, Paper, Typography } from "@mui/material";
import cookieBannerStyle from "./cookieBannerStyle";
import { allowAll, denyAll, checkConsentEntry } from "../../services/cookieService";
import { Link } from "react-router-dom";
import CookieModal from "./CookieModal";

const CookieBanner = () => {
  const [isConfigureOpen, setIsConfigureOpen] = useState(false);
  const [isSelectionMade, setIsSelectionMade] = useState(false);

  if (isSelectionMade || checkConsentEntry()) {
    return null;
  }

  return (
    <Paper sx={cookieBannerStyle.banner}>
      <Grid container alignItems={"center"} spacing={4}>
        <Grid item md={8} xs={12}>
          <Typography sx={cookieBannerStyle.headline} fontWeight={"bold"}>
            Schutz Ihrer Daten
          </Typography>
          <p>
            Für ein optimales Website-Erlebnis nutzen wir Cookies und ähnliche Technologien, um personalisierte Inhalte zu zeigen, Funktionen anzubieten und
            Statistiken zu erheben. Ein Klick auf "Akzeptieren" erlaubt uns diese Datenverarbeitung sowie die Weitergabe an Drittanbieter gemäß unserer
            Datenschutzerklärung. Personalisieren Sie ihre Cookie-Einstellungen (dies ist auch nachträglich jederzeit im Bereich Datenschutz möglich) oder
            klicken Sie auf "Ablehnen", wenn Sie nicht möchten, dass wir Cookies zu diesem Zweck verwenden. Weitere Informationen finden Sie unter{" "}
            <Link to={"/datenschutz"}>Datenschutzerklärung</Link>, <Link to={"/agb"}>AGB</Link> oder <Link to={"/impressum"}>Impressum</Link>.
          </p>
        </Grid>
        <Grid item md={4} xs={12}>
          <Grid container justifyContent={"space-between"} spacing={2}>
            <Grid item md={4} xs={6}>
              <Button fullWidth onClick={() => setIsConfigureOpen(true)} color={"primary"}>
                Konfigurieren
              </Button>
            </Grid>
            <Grid item lg={4} xs={6}>
              <Button
                fullWidth
                onClick={() => {
                  setIsSelectionMade(true);
                  denyAll();
                }}
                color={"primary"}
              >
                Ablehnen
              </Button>
            </Grid>
            <Grid item lg={4} xs={12}>
              <Button
                fullWidth
                onClick={() => {
                  setIsSelectionMade(true);
                  allowAll();
                }}
                variant={"contained"}
                color={"primary"}
              >
                Akzeptieren
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <CookieModal isSelectionMade={isSelectionMade} setIsSelectionMade={setIsSelectionMade} open={isConfigureOpen} setIsConfigureOpen={setIsConfigureOpen} />
    </Paper>
  );
};

export default CookieBanner;
